import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { Sticky } from 'react-sticky';
import moment from 'moment';

import { getDistanceLabel } from '../RaceSummary/helpers';

import Actions from './Actions';
import BookNow from './BookNow';
import Container from '../Container';
import StarRating from '../StarRating';

import {
  bookNow,
  container,
  header,
  heading,
  race,
  review,
} from './styles.module.css';

const formatStartDate = (startDate, races) => {
  if (races && races.races.length === 1) {
    return races.races[0].startTime
      ? moment.utc(races.races[0].startDate).format('h:mma ddd Do MMM YYYY')
      : moment.utc(races.races[0].startDate).format('ddd Do MMM YYYY');
  }
  return moment.utc(startDate).format('ddd Do MMM YYYY');
};

/**
 * EventHeader
 */
const EventHeader = ({
  id,
  location,
  onShare,
  organiser,
  races,
  reviews,
  permalink,
  source,
  startDate,
  title,
}) => (
  <Container className={container}>
    <div className={header}>
      <h1 className={heading}>{title}</h1>
      <date>{startDate ? formatStartDate(startDate, races) : 'TBC'}</date>
      {organiser && (
        <span>
          {' • by '}
          <Link to={organiser.permalink}>{organiser.title}</Link>
        </span>
      )}
      {location && <div>{location}</div>}
      {races && races.races.length === 1 && (
        <div className={race}>{`${getDistanceLabel(races.races[0])}`}</div>
      )}
    </div>
    {reviews &&
      reviews.total > 0 && (
        <div className={review}>
          {`${reviews.totalFormatted} ${reviews.total === 1 ? 'review' : 'reviews'}`}
          <StarRating value={reviews.ratings.overall} small />
        </div>
      )}
    <div className={bookNow}>
      <Sticky bottomOffset={30}>
        <BookNow
          organiser={organiser}
          permalink={permalink}
          races={races}
          source={source}
          startDate={startDate}
        />
      </Sticky>
    </div>
    <Actions
      id={id}
      onShare={onShare}
      organiser={organiser}
      permalink={permalink}
      races={races}
      startDate={startDate}
      title={title}
    />
  </Container>
);

EventHeader.propTypes = {
  id: PropTypes.number.isRequired,
  location: PropTypes.string.isRequired,
  onShare: PropTypes.func,
  organiser: PropTypes.shape({
    permalink: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
  permalink: PropTypes.string,
  races: PropTypes.shape(),
  reviews: PropTypes.shape(),
  source: PropTypes.string,
  startDate: PropTypes.string,
  title: PropTypes.string.isRequired,
};

EventHeader.defaultProps = {
  onShare: () => {},
  organiser: null,
  permalink: null,
  races: undefined,
  reviews: null,
  source: undefined,
  startDate: null,
};

export default EventHeader;



// WEBPACK FOOTER //
// ./app/src/components/EventHeader/index.jsx